export type QuoteEmailData = {
  version: string;
  companyName: string;
  firstName: string;
  reference: string;
};

export const quoteEmailTemplate = (data: QuoteEmailData) => `<!DOCTYPE html>
<html>
    <body>
    <p>Bonjour ${data.firstName},</p>
    <p>Merci d'avoir consulté ${data.companyName}, vous trouverez en copie de ce mail notre meilleure offre pour ce projet.</p>
    <p>&nbsp;</p>
    <p>Nous restons à votre disposition,</p>
    <p>&nbsp;</p>
    <p>Bonne journée,</p>
    <p>L'équipe Fabera pour ${data.companyName}</p>
    </body>
</html>
`;

export const quoteEmailDefaultTemplate = (data: QuoteEmailData) => {
  return `Bonjour ${data.firstName},

Merci d'avoir consulté ${data.companyName}, vous trouverez en copie de ce mail notre meilleure offre pour ce projet.
  
Nous restons à votre disposition,
  
Bonne journée,
L'équipe Fabera pour ${data.companyName}`;
};
